import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { getCurrentCoordinates } from "../../utils/geoHelper";
import { GeoCoordinates } from "../../types/works";

/**
 * Captures a geo-stamp for a driver step and surfaces the result as a toast.
 * Reuses the platform's `getCurrentCoordinates` (never throws — denied/unavailable
 * resolves to null). Phase 1 attaches this to every button press; Phase 2 will
 * capture rounds automatically via geofence.
 */
export const useGeoStamp = () => {
  const { t } = useTranslation("works");
  const [capturing, setCapturing] = useState(false);

  const capture = useCallback(async (): Promise<GeoCoordinates | undefined> => {
    setCapturing(true);
    try {
      const coords = await getCurrentCoordinates();
      if (coords) toast.success(t("driver.geo.captured"));
      else toast.info(t("driver.geo.unavailable"));
      return coords ?? undefined;
    } finally {
      setCapturing(false);
    }
  }, [t]);

  return { capture, capturing };
};
